import { Routes } from '@angular/router';
import { loggedInGuard } from "@core/guards/logged-in.guard";
import { loggedOutGuard } from "@core/guards/logged-out.guard";
import { roleGuard } from "@core/guards/role.guard";
import { Role } from "@core/models/roles.enum";

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./modules/dashboard/dashboard.page').then(m => m.DashboardPage),
    canActivate: [loggedInGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./modules/auth/pages/login/login.page').then(m => m.LoginPage),
    canActivate: [loggedOutGuard]
  },
  {
    path: 'logout',
    loadComponent: () => import('./modules/auth/pages/logout/logout.page').then(m => m.LogoutPage),
    canActivate: [loggedInGuard]
  },
  {
    path: 'profile',
    loadComponent: () => import('./modules/auth/pages/profile/profile.page').then(m => m.ProfilePage),
    canActivate: [loggedInGuard]
  },
  {
    path: 'travel-document',
    loadChildren: () => import('./modules/travel-document/travel-document.routes').then(m => m.routes),
    canActivate: [loggedInGuard, roleGuard],
    data: { roles: [Role.client_locomotive_driver] }
  },
  {
    path: 'work-time',
    loadChildren: () => import('./modules/work-time/work-time.routes').then(m => m.routes),
    canActivate: [loggedInGuard, roleGuard],
    data: { roles: [Role.client_locomotive_driver] }
  },
  {
    path: 'trip',
    loadChildren: () => import('./modules/trip/trip.routes').then(m => m.routes),
    canActivate: [loggedInGuard, roleGuard],
    data: { roles: [Role.client_locomotive_driver, Role.client_user, Role.client_admin] }
  }
];
